export const BOOTSTRAP_BACKUPS = 'BOOTSTRAP_BACKUPS'
export const SET_TOTAL_BACKUPS = 'SET_TOTAL_BACKUPS'
export const DELETE_BACKUP = 'DELETE_BACKUP'
export const ADD_BACKUP = 'ADD_BACKUP'
export const DELETE_MULTIPLE_BACKUPS = 'DELETE_MULTIPLE_BACKUPS'
export const SET_SELECTED_BACKUPS = 'SET_SELECTED_BACKUPS'
export const SET_SELECT_ALL_STATE = 'SET_SELECT_ALL_STATE'